import { EMR_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useEMRDownloadAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (emrId: string) => {
      dispatch(
        setLoading({
          key: "isEMRDownloadViewInProgress",
          status: true,
        }),
      );

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        // If no access token is found, redirect to login
        if (!accessToken) {
          toast.error("You are not logged in. Please log in again.");

          return;
        }

        // Make the request to download the PDF
        const response = await axios.get(`${EMR_APIS?.EMR_DOWNLOAD_API?.baseURL}?is_download=0&emr_id=${emrId}`, {
          responseType: "arraybuffer",
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/pdf",
          },
        });

        // Log headers to inspect the response
        console.log(response.headers);

        // Extract the filename from the Content-Disposition header
        const contentDisposition = response.headers["content-disposition"] || response.headers["Content-Disposition"];

        // If filename is not found, fall back to a default filename
        const filenameMatch = contentDisposition?.match(/filename="(.+)"/);
        const filename = filenameMatch ? filenameMatch[1] : "downloaded.pdf"; // Fallback filename if not found

        // Create a Blob and trigger the download
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        const downloadUrl = window.URL.createObjectURL(blob);
        link.href = downloadUrl;
        link.download = filename; // Set the filename dynamically
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl); // Cleanup the object URL
        console.log(blob, "downloadUrl");
        toast.success("PDF downloaded successfully!");

        return response;
      } catch (error) {
        // If we get a 401 Unauthorized error, log the user out
      } finally {
        // Ensure loading state is reset
        dispatch(
          setLoading({
            key: "isEMRDownloadViewInProgress",
            status: false,
          }),
        );
      }
    },
    [dispatch, captureError, sendCurl, configuration.localStorage.ACCESS_TOKEN.key, history],
  );

  return execute;
};
